const answersTodtenweis= {
  1: {
    1: "Richtig.",
    2: "Falsch. Die Ungarn setzen in erster Linie ihre gefürchteten Bögen ein.",
    3: "Falsch. Dolche sind für eine Schlacht denkbar schlechte Waffen."
  },
  2: {
    1: "Falsch. Mit so einer ungeschickten Idee hätten die Ungarn ihren größten Vorteil, die Beweglichkeit, eingebüßt.",
    2: "Richtig.",
    3: "Falsch. Die Ungarn trugen zum Schutz höchstens feste Lederkleidung, die nur sehr wenig mit Metal abgedeckt war."
  },
  3: {
    1: "Falsch. Mit so steinzeitlichen Waffen hätten die Ottonen den Ungarn nicht standhalten können.",
    2: "Falsch. Gewehre gab es zu dieser Zeit noch lange nicht.",
    3: "Richtig."
  },
  4: {
    1: "Falsch. Prächtiges Sattelzeug war den Pferden der ungarischen Anführer und Fürsten vorbehalten.",
    2: "Richtig.",
    3: "Falsch. Das hätte die Wendigkeit der ungarischen Pferde eingeschränkt. Außerdem wäre der Eisenbedraf bei so vielen Pferden viel zu hoch gewesen."
  },
  5: {
    1: "Richtig.<p>Gratuliere!\&nbsp;Damit haben Sie die Station erfolgreich abgeschlossen.</p><p> Laden Sie sich die App herunter, denn dort können Sie der Geschichte der Lechfeldschlacht noch besser und mit zahlreichen Spielen erleben.</p>",
    2: "Falsch. Niemand hat einen Vorteil davon, wenn er einfach nur geradeaus reitet.",
    3: "Falsch. Tarnkleidung im Kampf war damals nicht üblich, höchstens für Späher."
  }
}

export default answersTodtenweis;